import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { components } from 'react-select';
export const MenuList = props => {
  return _jsx(components.MenuList, {
    ...props,
    // @ts-expect-error FIXME
    innerProps: {
      ...props.innerProps,
      ...props.selectProps.menuListProps
    }
  });
};